import React, { useRef, useMemo, useState, useEffect, useContext } from 'react'
import JoditEditor from 'jodit-react';
import { Button } from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2'
import { SchoolContex } from '../../Helper/Contex';
import api from '../../API/api';


const AddCareerForm = (props) => {

    const { schools } = useContext(SchoolContex)
    console.log(props.modalData, 'iseit');
    

    const [data, setData] = useState({
        post: '',
        qualification: '',
        start_date: '',
        end_date: '',
        details: '',
        school: '',
    })

    const [load, setLoad] = useState(false);

    const handleInput = (e) => {
        setData({
            ...data, [e.target.name]: e.target.value
        })
    }



    const handleSubmit = () => {
        setLoad(true)

        let datas = {
            post: data.post,
            qualification: data.qualification,
            start_date: data.start_date,
            end_date: data.end_date,
            details: data.details,
            school: data.school,
            // isEdit : props.modalData?.id ? 1 : 0,
            id : props.modalData?.career_id ? props.modalData?.career_id : 0,
        }

        // console.log("dd==>", datas);
        api.saveCareer(datas).then((res) => {
            // console.log("respo=>", res);
            // return;
            props.handleClose();
            setLoad(false)
            Swal.fire({
                title: 'Success!',
                text: 'Added Succeffully !',
                icon: 'success',
                confirmButtonText: 'Ok'
            })

        })
            .catch((err) => {
                setLoad(false)
                // console.log("erro=>", err);
                Swal.fire({
                    title: 'Error!',
                    text: 'Something went wrong !',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            })

    }


    React.useEffect(() => {
        if (props.modalData.id !== 'undefined' || '') {
            setData(props.modalData)
        }
    }, [props])

    return (
        <>
            <div className='row'>

                <div className='col-md-12 p-2'>
                    <label htmlFor=""> Post Name</label>
                    <input type="text" className='form-control' name="post" value={data.post} onChange={handleInput} id="" />
                </div>
                <div className='col-md-4 p-2'>
                    <label htmlFor=""> Under School</label>

                    <select name="school" value={data.school} onChange={handleInput} className='form-control' id="">
                        <option value="">--Selest--</option>
                        {schools && schools.map((s) => (
                            <option value={s.id}>{s.schoolName}</option>
                        ))}
                    </select>

                </div>

                <div className='col-md-4 p-2'>
                    <label htmlFor="">Start Date:</label>
                    <input type="date" className='form-control' name="start_date" id="" value={data.start_date} onChange={handleInput} />
                </div>
                <div className='col-md-4 p-2'>
                    <label htmlFor="">Last Date of Submission:</label>
                    <input type="date" className='form-control' name="end_date" id="" value={data.end_date} onChange={handleInput} />
                </div>



                <div className='col-md-12 p-2'>
                    <label htmlFor="">Minimum Qualification</label>
                    <input type="text" className='form-control' name="qualification" value={data.qualification} onChange={handleInput} id="" />
                </div>



                <div className='col-md-12 p-2'>
                    <label htmlFor="">Short Description(Optional):</label>
                    <input type="text" className='form-control' name="details" id="" value={data.details} onChange={handleInput} />
                </div>


                <div className='col-md-12 p-4 text-center'>
                    <Button variant='contained' disabled={load ? true : false} onClick={handleSubmit}>Save Career</Button>
                </div>



            </div>
        </>
    )
}

export default AddCareerForm;